<template>
  <section class="custom-wrapper">
    <table class="custom-profile-table">
      <tbody>
        <tr>
          <td>Total Time Goal:</td>
          <td colspan="2">
            <span class="custom-zone-label">{{ totalMinutes }}</span>
            <span class="custom-mins-label">minutes</span>
          </td>
        </tr>
        <tr>
          <td>
            <span>Below Zone Goal:</span><br />
            <span class="custom-zone-range-label">{{ rangeBelowZone }}</span>
          </td>
          <td class="custom-zone-value">
            <span class="custom-zone-label">{{ percentBelowZone }}</span>
            <span class="custom-zone-percent-label">%</span>
          </td>
          <td>
            <span class="custom-zone-label">{{ minutesBelowZone }}</span>
            <span class="custom-mins-label">mins</span>
          </td>
        </tr>
        <tr>
          <td>
            <span>In Zone Goal:</span><br />
            <span class="custom-zone-range-label">{{ rangeInZone }}</span>
          </td>
          <td class="custom-zone-value">
            <span class="custom-zone-label">{{ percentInZone }}</span>
            <span class="custom-zone-percent-label">%</span>
          </td>
          <td>
            <span class="custom-zone-label">{{ minutesInZone }}</span>
            <span class="custom-mins-label">mins</span>
          </td>
        </tr>
        <tr>
          <td>
            <span>Above Zone Goal:</span><br />
            <span class="custom-zone-range-label">{{ rangeAboveZone }}</span>
          </td>
          <td class="custom-zone-value">
            <span class="custom-zone-label">{{ percentAboveZone }}</span>
            <span class="custom-zone-percent-label">%</span>
          </td>
          <td>
            <span class="custom-zone-label">{{ minutesAboveZone }}</span>
            <span class="custom-mins-label">mins</span>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'progress-goals',
  computed: {
    ...mapGetters('usercardio', ['memberGoals']),
    totalMinutes() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          _data = this.memberGoals.cardioProgram[0].TotalMinutes
        }
      }
      return _data
    },
    rangeBelowZone() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          _data = this.memberGoals.cardioProgram[0].BelowZoneRange
        }
      }
      return _data
    },
    percentBelowZone() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          if (this.memberGoals.cardioProgram.length > 0) {
            _data = parseFloat(
              this.memberGoals.cardioProgram[0].PercentBelowZone
            ).toFixed(0)
          }
        }
      }
      return _data
    },
    minutesBelowZone() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          if (this.memberGoals.cardioProgram.length > 0) {
            _data = parseFloat(
              this.memberGoals.cardioProgram[0].MinutesBelowZone
            ).toFixed(1)
          }
        }
      }
      return _data
    },
    rangeInZone() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          if (this.memberGoals.cardioProgram.length > 0) {
            _data = this.memberGoals.cardioProgram[0].InZoneRange
          }
        }
      }
      return _data
    },
    percentInZone() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          if (this.memberGoals.cardioProgram.length > 0) {
            _data = parseFloat(
              this.memberGoals.cardioProgram[0].PercentInZone
            ).toFixed(0)
          }
        }
      }
      return _data
    },
    minutesInZone() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          if (this.memberGoals.cardioProgram.length > 0) {
            _data = parseFloat(
              this.memberGoals.cardioProgram[0].MinutesInZone
            ).toFixed(1)
          }
        }
      }
      return _data
    },
    rangeAboveZone() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          if (this.memberGoals.cardioProgram.length > 0) {
            _data = this.memberGoals.cardioProgram[0].AboveZoneRange
          }
        }
      }
      return _data
    },
    percentAboveZone() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          if (this.memberGoals.cardioProgram.length > 0) {
            _data = parseFloat(
              this.memberGoals.cardioProgram[0].PercentAboveZone
            ).toFixed(0)
          }
        }
      }
      return _data
    },
    minutesAboveZone() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          if (this.memberGoals.cardioProgram.length > 0) {
            _data = parseFloat(
              this.memberGoals.cardioProgram[0].MinutesAboveZone
            ).toFixed(1)
          }
        }
      }
      return _data
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  position: relative;
  width: 350px;
  padding: 5px;
}
.custom-profile-table th,
td {
  padding: 8px;
  vertical-align: top;
}
.custom-zone-value {
  text-align: right;
}
.custom-zone-label {
  font-size: 1em;
  margin-left: 5px;
}
.custom-zone-range-label {
  margin-left: 5px;
  font-size: 0.8em;
}
.custom-zone-percent-label {
  margin-top: 8px;
  margin-left: 3px;
  margin-right: 10px;
}
.custom-mins-label {
  margin-left: 3px;
}
</style>
